import React, { FC, useMemo, useRef } from 'react';
import InfiniteScroller from '../InfiniteScroller';
import ErrorBox from '../ErrorBox/ErrorBox';
import { useFillHeightToFitScreen } from 'hooks/general/useFillHeightToFitScreen';
import styled from '@emotion/styled';
import { Table } from 'antd';
import { colorConstants } from 'config/colorConstants';
import tw from 'twin.macro';
import TableErrorBox from '../ErrorBox/TableErrorBox';
import { getPlanComparisonTableColumns } from 'utils/getTradePromoOptimizationTableColumns';

const planComparisonTableId = 'plan-comparison-table-id';

export const CustomTable = styled(Table)`
    // .ant-table-sticky-scroll {
    //     position: static;
    // }
    .ant-table-thead > tr > th {
        background: ${colorConstants.grey};
        //padding: 0px;
        // height: 68px;
    }
    .ant-table-header col:not(:last-child),
    .ant-table-thead
        > tr
        > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
            [colspan]
        ):before {
        background: none;
    }
    .ant-table-column-sorter {
        position: relative;
        left: -10px;
    }
    .ant-table-column-sorter-down.active,
    .ant-table-column-sorter-up.active {
        ${tw`text-purpleFont`};
    }
    // border: ${'1px solid #DBDFE9'};
`;

type Props = {
    data: any;
    loading: boolean;
    error: any;
    arePlansSelected: boolean;
};

const PlanComparisonTableContainer: FC<Props> = ({ data, error, loading, arePlansSelected }) => {
    const commonLoading = loading;
    const dataCount = 0;

    const tableHeight = useRef<number | null>(0);

    //this hook with give height to fill the screen height
    tableHeight.current = useFillHeightToFitScreen({
        id: planComparisonTableId,
        height: tableHeight.current,
        buffer: 100, //footer
    });

    const columns = useMemo(() => {
        if (!data?.length) return [];
        return getPlanComparisonTableColumns(data);
    }, [data]);

    function infiniteScrollOnNext(loading: boolean) {}
    const dataIncludingHeader = data?.length ? [{ key: 'comparison-table-header' }, ...data] : data;
    return (
        <div className="">
            <InfiniteScroller
                data={data}
                loading={commonLoading}
                hasMore={data?.length < (dataCount || 0) || commonLoading}
                height={
                    data && !error
                        ? tableHeight.current ?? undefined
                        : isNaN(Number(tableHeight.current))
                        ? undefined
                        : Number(tableHeight.current) - 1
                } //there should be a change in height when its loading and not loading, thats the reason for subtracting 1}
                //height={200}
                //     loader={true}
                onNext={() => infiniteScrollOnNext(commonLoading)}
            >
                <CustomTable
                    bordered
                    onChange={(pagination, filter, sort: any, extra) => {
                        if (sort?.order) {
                            const sortMapping: any = {
                                descend: 'desc',
                                ascend: 'asc',
                            };

                            //   setTableReactQueryVariables({
                            //       ...tableReactQueryVariables,
                            //       sort_by: sort?.column?.sortKey,
                            //       sorting_order: sortMapping?.[sort?.order] || 'desc',
                            //       offset: 0,
                            //   });
                            //default it to dim1 column on cancelling sorting
                        } else {
                            //   setTableReactQueryVariables({
                            //       ...tableReactQueryVariables,
                            //       sort_by: 'updated_at',
                            //       sorting_order: 'desc',
                            //       offset: 0,
                            //   });
                        }
                    }}
                    sticky={{
                        getContainer: () =>
                            document.getElementsByClassName('infinite-scroll-component')?.[0] as HTMLElement,
                    }} //adding x axis scrollbar on table
                    id={planComparisonTableId}
                    columns={columns}
                    // loading={commonLoading}
                    scroll={{ x: '100%' }}
                    dataSource={dataIncludingHeader}
                    pagination={false}
                    style={{
                        opacity: commonLoading ? '0.3' : 1,
                        pointerEvents: commonLoading ? 'none' : 'auto',
                    }}
                    locale={{
                        emptyText: !arePlansSelected ? (
                            <TableErrorBox
                                showIcon={false}
                                error={'Click on Plan Comparison Setup above to start with Plan Comparison'}
                                height={tableHeight.current}
                            />
                        ) : commonLoading ? (
                            <></>
                        ) : error ? (
                            <TableErrorBox error={error} height={tableHeight.current} />
                        ) : (
                            ''
                        ),
                    }}
                />
            </InfiniteScroller>
        </div>
    );
};

export default PlanComparisonTableContainer;
